import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "dialog", "closeButton", "submitButton", "submitBeeButton", "dialogForm", "fieldType", "deleteButton", "spotsSwitch", "spotsInput", "acceptCookies"]

  initialize () { 
    let _this = this,
        form_changed = false;

    if (_this.hasDialogTarget) {

      let dialog = _this.dialogTarget;
          
      if (_this.hasSubmitBeeButtonTarget ) {
        _this.submitBeeButtonTarget.addEventListener('click', function() {
          // Custom event we will use as our trigger
          const trigger = new CustomEvent("trigger-save");
          window.dispatchEvent(trigger);
        });
      }

      if (_this.hasDialogFormTarget && _this.hasSubmitButtonTarget) {
        let form = _this.dialogFormTarget;

        form.addEventListener("input", function () {
          if (_this.hasCloseButtonTarget) {
            form_changed = true;
            _this.submitButtonTarget.classList.remove('hidden');
          }
        });

        form.addEventListener("turbo:submit-end", function (event) { 
          if (event.detail.success)
            dialog.close();
        });

        if (_this.hasFieldTypeTarget ) {
          _this.fieldTypeTarget.addEventListener('change', function() {
            form.setAttribute("field-type", _this.fieldTypeTarget.value)
          });
        }

      }

      if (_this.hasDeleteButtonTarget ) {
        _this.deleteButtonTarget.addEventListener("click", function () { 
          if (!confirm(_this.deleteButtonTarget.dataset.confirm)) { 
            event.preventDefault(); 
          } else {
            dialog.close();
          }
          
        });

      }

      if (_this.hasSpotsSwitchTarget && _this.hasSpotsInputTarget) {


        _this.spotsSwitchTarget.addEventListener('change', function() {
          console.log(_this.spotsSwitchTarget.selected);

          if (_this.spotsSwitchTarget.selected) {
            _this.spotsInputTarget.style.display = "block";
            _this.spotsInputTarget.focus();
          } else {
            _this.spotsInputTarget.style.display = "none";
            _this.spotsInputTarget.value = 0;

          }

        });

          
        

      }

      dialog.addEventListener('cancel', function(event) {
        console.log("prevent cancel", dialog.classList.contains("prevent-cancel"));
        if (form_changed || dialog.classList.contains("prevent-cancel")) {
          event.preventDefault();
          console.log("Dialog cancel");
        }

      });

      if (_this.hasCloseButtonTarget ) {
        _this.closeButtonTarget.addEventListener('click', function() {
          dialog.close();
        });
      }


      if (_this.hasAcceptCookiesTarget ) {
        _this.acceptCookiesTarget.addEventListener('click', function() {
          document.cookie = "cookies-accepted=true"

          dialog.close();
        });
      }

    }

  }

}